import React, { useEffect, useState } from 'react';
import { Card, Typography, Row, Col, Button, Divider, Space, message,Grid, Modal } from 'antd';
import { EnvironmentOutlined, CalendarOutlined, FileTextOutlined, LikeOutlined } from '@ant-design/icons';
import { formatString } from '../Common/ColorCode';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import ClinicMap from './ClinicMap';
import { filterByNonGpProductId } from '../Common/CommonFunction'
import "../BookingJourney/StepComponents/Step4.css"
// ldcbe-patient\src\utils\HashUtils.js
// ldcbe-patient\src\Component\Dashboard\BookingConfirmation.js
import { hashSHA256, formatPhone } from "../../utils/HashUtils"
import {DIAL_MAP} from "../../utils/Countery"


const nameFromDial = Object.fromEntries(
  Object.entries(DIAL_MAP).map(([d, n]) => [d.replace(/\D/g, ''), n])
);
export function getCountryName(dial) {
  const digits = String(dial).replace(/\D/g, '');
  return nameFromDial[digits] || null;
}

const { Title, Text } = Typography;
let tempData = {
  product: 'General GP consultation',
  data: [
    {
      key: 'Duration',
      data: '15 minutes'
    },
    {
      key: 'Language',
      data: 'Arabic'
    },
    {
      key: 'Gender',
      data: 'Male'
    },
  ],
  date: '14 January, 2025',
  time: '10:30',
  name: "Oxford Street",
  address: "6 Newburgh Street, Carnaby, London, W1F 7RQ",
}

const BookingConfirmation = (props) => {
        const latitude = props?.BookedAppointmentPayload?.data?.latitude || 37.7749; 
  const longitude = props?.BookedAppointmentPayload?.data?.longitude || -122.4194;

  // console.log("props:Booking_Confirmation", props)
  // Calendar modal state
const [calendarModalOpen, setCalendarModalOpen] = useState(false);

// Helper to generate ICS file content (move outside component)
function generateICS({ title, details, location, formattedStart, formattedEnd }) {
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `SUMMARY:${title}`,
    `DESCRIPTION:${details}`,
    `LOCATION:${location}`,
     `DTSTART:${moment(formattedStart).utc().format('YYYYMMDDTHHmmss')}Z`,
    `DTEND:${moment(formattedEnd).utc().format('YYYYMMDDTHHmmss')}Z`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\n');
}

// Handler to download ICS file (outside component, pass props)
const handleDownloadICS=(props, setCalendarModalOpen, calendarDate)=>{
  // Use showAppoinmentData for ICS file
  const data = props.showAppoinmentData;
  // console.log('Generating ICS for data:', data);
  let payload = {};
  if (data) {
    let hstitle = props?.showAppoinmentData.clinic?.productCategory?.product_category_id  == 2 ?  getProductName(props?.showAppoinmentData?.clinic?.non_gp_product_id)   : null;
    const title = hstitle ? data.clinic?.productCategory?.title +' - '+ hstitle : (data.clinic?.productCategory?.title || 'Appointment');
    const details = `Type: ${data.type || ''}\nLanguage: ${data.language || ''}\nGender: ${data.gender || ''}`;
    const location = data.slot?.clinicData?.name +', '+ data.slot?.clinicData?.address || 'Clinic';
    // Parse date and time for start/end
    const dateStr = data.slot?.date || '';
    const timeStr = data.slot?.info?.start_time || '';
    // Try to parse date like 'Fri, 29 Aug2025' and time '12:45'
    let startDateTime = '';
    if (dateStr && timeStr) {
      // Try to parse with moment
      const m = moment(dateStr + ' ' + timeStr, ['ddd, DD MMMYYYY HH:mm', 'ddd, DD MMM YYYY HH:mm', 'ddd, DD MMMYYYYHH:mm', 'ddd, DD MMM YYYYHH:mm']);
      if (m.isValid()) {
        startDateTime = m.format('YYYY-MM-DDTHH:mm:ss');
      } else {
        // fallback: just use today
        startDateTime = moment().format('YYYY-MM-DDT') + timeStr + ':00';
      }
    } else {
      startDateTime = moment().format('YYYY-MM-DDTHH:mm:ss');
    }
    // Assume 15 min duration if not specified
    let durationMin = 15;
    if (data.duration && !isNaN(Number(data.duration))) {
      durationMin = Number(data.duration) * 15;
    }
    const endDateTime = moment(startDateTime).add(durationMin, 'minutes').format('YYYY-MM-DDTHH:mm:ss');
  const formattedEnd = props?.BookedAppointmentPayload?.data?.end_time
  const formattedStart = props?.BookedAppointmentPayload?.data?.start_time
    payload = {
      title,
      details,
      location,
      formattedStart,
      formattedEnd
    };
  } else {
    // fallback dummy data
    payload = {
      title: 'Appointment',
      details: 'Appointment details',
      location: '123 Clinic St, Springfield',
      startDateTime: calendarDate('2025-05-15T09:00:00'),
      endDateTime: calendarDate('2025-05-15T09:30:00')
    };
  }
  const icsContent = generateICS(payload);
  const blob = new Blob([icsContent.replace(/\n/g, '\r\n')], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'appointment.ics';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  setCalendarModalOpen(false);
}
const latRounded = Math.round(latitude * 10000) / 10000;
  const lngRounded = Math.round(longitude * 10000) / 10000;
  useEffect(() => {
        window.scrollTo(0, 0);
  }, []);
  const [messageApi, contextHolder] = message.useMessage();
  
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // // Add the GA tracking useEffect here
  // useEffect(() => {
  //   const userData = props.userData
  //   if (props.user) {
  //     window.dataLayer = window.dataLayer || [];
  //     window.dataLayer.push({
  //       event: "enhanced_conversion",
  //       user_data: {
  //         email: props.user.email,
  //         phone_number: props.user.phone,
  //         address: {
  //           first_name: props.user.firstName,
  //           last_name: props.user.lastName,
  //           city: props.user.city,
  //           postal_code: props.user.postalCode,
  //           country: props.user.country
  //         }
  //       }
  //     });
  //   }
  // }, [props.user]);

    // Add the GA enhanced conversion tracking
  useEffect(() => {
    const userData = props.userData;
    if (userData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "enhanced_conversion",
        user_data: {
          email: hashSHA256(userData.email), // Hashed email
          phone_number: hashSHA256(formatPhone(userData.mobile)), // Hashed and formatted phone
          address: {
            first_name: hashSHA256(userData.firstName), // Hashed first name
            last_name: hashSHA256(userData.lastName), // Hashed last name
            city: hashSHA256(userData.city || ''), // Add if available
            postal_code:hashSHA256(props?.BookedAppointmentPayload?.data?.postal_code || ''), // Add if available
            country: hashSHA256(getCountryName(userData?.country) || 'GB') // Default to GB
          }
        }
      });
      
      // console.log('Google_Analytics -> Enhanced conversion event fired with user data:', userData,window.dataLayer);
    }
  }, [props.userData]); // Run when userData changes


  // Add this useEffect for purchase tracking
useEffect(() => {

  if(props?.paymentIntentResponseCatchPayload){
    // console.log("paymentIntentResponseCatchPayload",props?.paymentIntentResponseCatchPayload);
    // console.log("paymentIntentResponseCatchPayload transactionID",props?.paymentIntentResponseCatchPayload?.data?.latest_charge);
  }
  if (props.showAppoinmentData && props.showAppoinmentData.price) {
    // const price = parseFloat(props.showAppoinmentData.price) || 0;
    const priceString = props.showAppoinmentData.price.replace(/£\s+/g, '').trim();
    const price = parseFloat(priceString) || 0;
    const clinicName = props?.showAppoinmentData?.slot?.clinicData?.name || 'Unknown Clinic';
    const productName = props?.showAppoinmentData.clinic?.productCategory?.title || props?.showAppoinmentData.clinic?.productCategory?.name || 'General GP consultation';
    const appointmentId = props?.BookedAppointmentPayload?.data?.appointment_id || 'unknown';
    const trasnaction_id = props?.paymentIntentResponseCatchPayload?.data?.latest_charge || 'unknown';
    if (trasnaction_id && !window.sessionStorage.getItem(trasnaction_id)) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        currency: 'GBP',
        value: price,
        // transaction_id: appointmentId,
        transaction_id: trasnaction_id,
        items: [{
          item_name: clinicName,
          item_id: productName,
          price: price,
          quantity: 1
        }]
      }
    });
    window.sessionStorage.setItem(trasnaction_id, 'sent');
  }

    let GA_data = {
      event: 'purchase',
      ecommerce: {
        currency: 'GBP',
        value: price,
        // transaction_id: appointmentId,
        transaction_id: trasnaction_id,
        items: [{
          item_name: clinicName,
          item_id: productName,
          price: price,
          quantity: 1
        }]
      }
    }
    // console.log('Google_Analytics -> Purchase event fired:', GA_data);
  }
}, [props.showAppoinmentData, props.BookedAppointmentPayload]);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  const applemap = () => {
      const latitude = props?.BookedAppointmentPayload?.data?.latitude || 37.7749; // example
  const longitude = props?.BookedAppointmentPayload?.data?.longitude || -122.4194;
const latRounded = Math.round(latitude * 10000) / 10000;
  const lngRounded = Math.round(longitude * 10000) / 10000;

    const url = `https://maps.apple.com/?q=${latRounded},${lngRounded}`
    // const url= `https://www.google.com/maps?q=${latRounded},${lngRounded}`

  // window.open(url, '_blank');
    // setIsModalOpen(false);
  };
  // console.log('::::::BookingConfirmation:::::', props)
  const navigate = useNavigate();
  
    const { useBreakpoint } = Grid;
      const screens = useBreakpoint();

  let tempDataForDuration = []
  if (props.showAppoinmentData && props.showAppoinmentData?.duration) {
    tempDataForDuration.push({
      key: 'Duration',
      data: props.data && props.data.durationObjectById && props.showAppoinmentData.duration && props.data.durationObjectById[props.showAppoinmentData.duration] ? props.data.durationObjectById[props.showAppoinmentData.duration].duration + ' minutes' : '15 minutes'
    })
  }
  if (props.showAppoinmentData && props.showAppoinmentData?.language &&  props.showAppoinmentData?.language !== "English") {
    let data = ''
    if (props.showAppoinmentData.language && props.showAppoinmentData.language.value) {
      data = props.showAppoinmentData.language.value
    } else {
      data = props.showAppoinmentData.language
    }
    let languageName = props?.data?.languageData.find(landata => landata.value == data)
    // console.log('languageName dfd', languageName)
    tempDataForDuration.push({
      key: 'Language',
      data: languageName ? languageName.label : props.showAppoinmentData.language
    })
  }
  if (props.showAppoinmentData && props.showAppoinmentData?.gender && props.showAppoinmentData?.gender !== "no_preference") {

    tempDataForDuration.push({
      key: 'Gender',
      data: props.showAppoinmentData.gender ? formatString(props.showAppoinmentData.gender) : ''
    })
  }
  const openMap = () => {
    let lat = 55.120204, lng = '-3.3682784'
    if (props.showAppoinmentData.slot.clinicData && props.showAppoinmentData.slot.clinicData.latitude && props.showAppoinmentData.slot.clinicData.longitude) {
      lat = props.showAppoinmentData.slot.clinicData.latitude
      lng = props.showAppoinmentData.slot.clinicData.longitude
    }
    if (lng == '') {
      messageApi.error({
        type: 'error',
        content: 'Longitude not found.',
      });
    }
    if (lat == '') {
      messageApi.error({
        type: 'error',
        content: 'Latitude not found.',
      });
    }
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, '_blank');
  }
  const openGoogleCalendarEvent = ({ title, details, location, startDateTime, endDateTime }) => {
    const url = new URL('https://www.google.com/calendar/render');
    url.searchParams.set('action', 'TEMPLATE');
    url.searchParams.set('text', title);
    url.searchParams.set('details', details);
    url.searchParams.set('location', location);
    url.searchParams.set('dates', `${formatForCalendar(startDateTime)}/${formatForCalendar(endDateTime)}`);
    window.open(url.toString(), '_blank');
  }

  function formatForCalendar(date) {
    return moment(date).utc().format('YYYYMMDDTHHmmss') + 'Z';
  }
  const addAppointmentOnGoogleCalender = () => {
    // console.log(':::::::addAppointmentOnGoogleCalender:::::',props.data)
    props.hideConfirm()
    // navigate('/clinic-calendar-page',{ state:{...props.data} })
    // return
    let payload = {}
    if (props.data?.clinic?.address && props?.showAppoinmentData?.confirm?.start_time && props?.showAppoinmentData?.confirm?.end_time && props?.showAppoinmentData?.confirm?.notes && props?.showAppoinmentData?.confirm.patient) {

      payload = {
        title: `${props?.showAppoinmentData?.confirm.patient.first_name} ${props?.showAppoinmentData?.confirm.patient.last_name}`,
        details: `${props?.showAppoinmentData?.confirm.notes}`,
        location: props.data?.clinic?.address ?? '123 Clinic St, Springfield',
        startDateTime: props?.showAppoinmentData?.confirm?.start_time ? calendarDate(props?.showAppoinmentData?.confirm?.start_time) : calendarDate('2025-05-15T09:00:00'),
        endDateTime: props?.showAppoinmentData?.confirm?.end_time ? calendarDate(props?.showAppoinmentData?.confirm?.end_time) : calendarDate('2025-05-15T09:30:00')
      }
    }
    // console.log('payload :::',payload)
    openGoogleCalendarEvent(payload)
  }
  const calendarDate = (input) => {
    return moment(input, "YYYY-MM-DD HH:mm").startOf('hour').format("YYYY-MM-DDTHH:mm:ss");
  }


  function cleanEscapedUrl(rawInput) {
  try {
    // Step 1: Remove backslashes
    const withoutSlashes = rawInput.replace(/\\/g, "");

    // Step 2: Remove surrounding quotes if present
    const trimmed = withoutSlashes.replace(/^"(.*)"$/, "$1");

    return trimmed;
  } catch (err) {
    console.error("Invalid input URL:", err);
    return null;
  }
}

  const  onConsultClick = ()=>{
    const url=props?.BookedAppointmentPayload?.consultation_url
    if (url) {
      window.open(url, '_blank')
    }
    // console.log("onConsultClick")
  }
//   const  onCalendarClick = ()=>{
    
//     console.log("onCalendarClick",props?.BookedAppointmentPayload?.google_calendar?.auth_url)
//   const url=props?.BookedAppointmentPayload?.google_calendar?.auth_url
//   const newTab=window.open(url, '_blank')

//   // Wait until the new tab is ready
// setTimeout(() => {
//   newTab.postMessage({ name: 'John Doe', id: 123 }, url); // targetOrigin must match
// }, 1000);
//   }


// const onCalendarClick = () => {
//   const authUrl = props?.BookedAppointmentPayload?.google_calendar?.auth_url;
//   const appointmentId = props?.BookedAppointmentPayload?.data?.appointment_id;
//   const token = localStorage.getItem("authToken");

//   // const popup = window.open(authUrl, '_blank', 'width=700,height=600');
//   const popup = window.open(authUrl, '_blank', );
//   localStorage.setItem("appointmentId", appointmentId);

//   console.log("authUrl", authUrl)

// };


const onCalendarClick = () => {
  // Prepare Google Calendar event details
  const data = props.showAppoinmentData;

  let title = "";
  let details = "";
  let location = "";
  let startDateTime = "";
  let endDateTime = "";

  // Always try to use real data, fallback to empty if not available
  // Title: Use product category or fallback
  title = (data?.clinic?.productCategory?.title || "Appointment").replace(/\s+/g, "+");
  // Details: Type, Language, Gender
  details = `Type: ${data?.type || ''} | Language: ${data?.language || ''} | Gender: ${data?.gender || ''}`.replace(/\s+/g, "+");
  // Location: Clinic name and address
  location = ((data?.slot?.clinicData?.name || "") + ", " + (data?.slot?.clinicData?.address || "")).replace(/\s+/g, "+");
  // Date/time
  const dateStr = data?.slot?.date || '';
  const timeStr = data?.slot?.info?.start_time || '';
  let start = '';
  if (dateStr && timeStr) {
    const m = moment(dateStr + ' ' + timeStr, ['ddd, DD MMMYYYY HH:mm', 'ddd, DD MMM YYYY HH:mm', 'ddd, DD MMMYYYYHH:mm', 'ddd, DD MMM YYYYHH:mm']);
    if (m.isValid()) {
      start = m.utc().format('YYYYMMDDTHHmmss');
    } else {
      start = moment().utc().format('YYYYMMDDTHHmmss');
    }
  } else {
    start = moment().utc().format('YYYYMMDDTHHmmss');
  }
  // Duration: 15 min default
  // const formattedTime = props?.BookedAppointmentPayload?.data?.end_time.replace(/-/g, "").replace(" ", "T") + "Z";
 const formatted = props?.BookedAppointmentPayload?.data?.end_time
  ?.replace(/[-: ]/g, "")   // remove -, :, and spaces
  ?.replace(/^(\d{8})(\d{6})$/, "$1T$2");
 const formattedStart = props?.BookedAppointmentPayload?.data?.start_time
  ?.replace(/[-: ]/g, "")   // remove -, :, and spaces
  ?.replace(/^(\d{8})(\d{6})$/, "$1T$2");
  let durationMin = 15;
  if (data?.duration && !isNaN(Number(data.duration))) {
    durationMin = Number(data.duration) * 15;
  }
  const end = moment(start, 'YYYYMMDDTHHmmssZ').add(durationMin, 'minutes').utc().format('YYYYMMDDTHHmmss') + 'Z';
  startDateTime = props?.BookedAppointmentPayload?.data?.start_time ? formattedStart : start; 
  endDateTime = props?.BookedAppointmentPayload?.data?.end_time ? formatted : end;
  // console.log("startDateTime:::",startDateTime,endDateTime,formatted,props?.BookedAppointmentPayload?.data?.end_time,end)
  const googleCalendarUrl =
    "https://calendar.google.com/calendar/render?action=TEMPLATE" +
    `&text=${title}` +
    `&dates=${startDateTime}/${endDateTime}` +
    `&details=${details}` +
    `&location=${location}`;

  window.open(googleCalendarUrl, "_blank");
};




  // const  onMapClick = ()=>{console.log("onMapClick")}

  const onMapClick = () => {
  // const latitude = 37.7749; // example
  // const longitude = -122.4194; // example
  const latitude = props?.BookedAppointmentPayload?.data?.latitude || 37.7749; // example
  const longitude = props?.BookedAppointmentPayload?.data?.longitude || -122.4194;
const latRounded = Math.round(latitude * 10000) / 10000;
  const lngRounded = Math.round(longitude * 10000) / 10000;
  // console.log("latitude_and_longitude", latitude, longitude,latRounded,lngRounded );
  const isAppleDevice = /iPhone|iPad|Macintosh|Mac OS|MacIntel/.test(navigator.userAgent);

  const url = isAppleDevice
    ? `https://maps.apple.com/?q=${latRounded},${lngRounded}`
    :  `https://www.google.com/maps?q=${latRounded},${lngRounded}`;
    // https://www.google.com/maps?q=51.5049116,-0.0216454
    // https://www.google.com/maps?q=37.4219983,-122.084

  window.open(url, '_blank');
};

  function getProductName(id) {
    let products;
  
    // Try to load from localStorage and parse to object
    const stored = localStorage.getItem('nongroupproductid');
    if (stored) {
      try {
        products = JSON.parse(stored); // parse string to object
      } catch (e) {
        console.error("Invalid JSON in localStorage");
        products = {}; // fallback to empty object on error
      }
    } else {
      // Fallback if nothing in localStorage
      products = {
        201: "Vital",
        202: "Bronze",
        203: "Silver",
        204: "Gold",
        205: "Platinum",
        4: "Vital (15 minutes)",
        5: "Bronze (60 minutes)",
        6: "Gold (90 minutes)",
        7: "Silver (75min)",
        10: "Platinum",
        18: "r888",
        20: "r888178",
        22: "Diamond"
      };
    }
  
    // console.log("productsproductsproducts", {products,id,});
    return products[id];
  }
  


  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', background: '#fff',marginTop:screens.md? "50px":"0px" ,marginBottom:"40px"}}>
      {contextHolder}
      <Title style={{ margin: 0, 
                                fontSize: "20px",
                                backgroundColor: 'rgba(0, 131, 133, 0.25)',
                                // fontFamily:"lato",
                                fontWeight:"400",
                                height:"44px",
                                display:"flex",
                                alignItems:"center",
                                color:"#008385",
                                padding:"10px",
                                // justifyContent:"center",
                                justifyContent: screens.md ? "center" : "flex-start",
                                // textAlign: screens.md ? "center" : "left",             // Optional: extra safety
                                paddingLeft: screens.md ? "0px" : "10px"  
                                }}><span >My booking</span>:</Title>

      <div style={{ marginTop:screens.md? "15px":"10px" ,margin:"15px 15px 15px 15px"}}>
        <div style={{ maxWidth: '410px',  margin:"auto",background: "#F0FAFA", padding: "10px 0px", border: '1px solid #008385', borderBottom: 'none', }}>
          <span style={{ margin: 0, fontSize: 14, color: '#008385' }}>{props?.showAppoinmentData && props?.showAppoinmentData.clinic && props?.showAppoinmentData.clinic?.productCategory && props?.showAppoinmentData.clinic?.productCategory?.title ? props?.showAppoinmentData.clinic?.productCategory?.title : 'General GP consultation'}</span>
          {props?.showAppoinmentData && props?.showAppoinmentData.clinic && props?.showAppoinmentData.clinic?.productCategory && props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 2 &&<br />}
          <span style={{ margin: 0, fontSize: 14, color: '#008385' }}>   {props?.showAppoinmentData && props?.showAppoinmentData.clinic && props?.showAppoinmentData.clinic?.productCategory && props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 2 && props?.showAppoinmentData.clinic.non_gp_product_id && props.getAllHealthScreenData && props.getAllHealthScreenData.getAllHealthScreenData?.data ? filterByNonGpProductId(props.getAllHealthScreenData.getAllHealthScreenData?.data, props?.showAppoinmentData.clinic.non_gp_product_id)?.length && filterByNonGpProductId(props.getAllHealthScreenData.getAllHealthScreenData?.data, props?.showAppoinmentData.clinic.non_gp_product_id)[0].name : ''}</span>
          {/* <br />   */}
          {props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 1 && tempDataForDuration && tempDataForDuration.length ? tempDataForDuration?.map((rs, i) => {
            return (
              <>
             {i%2 == 0 &&( <br/>)}
                <span style={{ color: '#4A4A4A', fontSize: 13 }}>{rs.key}:</span><span style={{ fontSize: 13, color: '#008385' }}> {rs.data} {tempData.data.length ==  i%2 == 0 ? i!==1? " | ":"" : ' | '}</span>
              </>
            )
          }) : ''}

          {
              props?.showAppoinmentData?.price && ( props?.showAppoinmentData.clinic?.productCategory
                ?.product_category_id  !== 2)  && 
              <>  { ( props?.showAppoinmentData?.gender !== "no_preference" ||  props?.showAppoinmentData?.language !== "English")  && ""}
              <span  style={{ color: '#4A4A4A', fontSize: 13 }}>
                {` Price: `} 
                 
                { <span style={{ fontSize: 13, color: '#008385' }}> {" "+props?.showAppoinmentData?.price  }</span>}
              </span>
              </>
          }

          {

            props?.showAppoinmentData.clinic?.productCategory
            ?.product_category_id  == 2 ? (
            <span style={{ fontSize: 14, color: '#008385', padding:5 }}>
                {getProductName(props?.showAppoinmentData?.clinic?.non_gp_product_id)  }
                <>
   {" | " }<span style={{ color: '#4A4A4A' }}>Price:</span>
  {/* {' $'} */}
  {props?.showAppoinmentData?.price}
</>
                
            </span>) : (null)
          }
        </div>
        <div style={{ maxWidth: '410px', background: "#F0FAFA", margin:"auto", borderTop: 'none', border: '1px solid #008583', height: 61 , display:"flex", alignItems:"center", justifyContent:"center"}}>
          <span style={{ margin: 0, fontSize: 20, color: '#4A4A4A' }}>{props.showAppoinmentData.slot?.date ? moment(`${props.showAppoinmentData.slot?.date} 2025`).format("D MMMM, YYYY") : tempData.date} | {props.showAppoinmentData.slot.info.start_time ? props.showAppoinmentData.slot.info.start_time : tempData.time}</span>
        </div>
        <div style={{ maxWidth: '410px', display: 'flex', justifyContent: 'flex-start',  margin:"20px auto" }}>
          <div className='remove-map-text' style={{ width: 90, height: 90, borderRadius: "10px", marginLeft: 1 }}>
            {/* <iframe
              width={76}
              height={76}
              style={{ border: "0", marginTop: 0 }}
              loading="lazy"
             src={`https://www.openstreetmap.org/export/embed.html?bbox=${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude},${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude}&layer=mapnik`}
            ></iframe> */}
            <ClinicMap widthAndheight={{ width: 76, height: 76, }} passData={{
              cood: [{
                id: props.showAppoinmentData?.slot?.clinicData?.id,
                name: props.showAppoinmentData?.slot?.clinicData?.name,
                data: [props.showAppoinmentData?.slot?.clinicData?.latitude, props.showAppoinmentData?.slot?.clinicData?.longitude]
              }]
            }} />
          </div>
          <div style={{ textAlign: 'left', marginLeft: 30 }}>
            <p style={{ fontSize: 14 }}>{props.showAppoinmentData?.slot?.clinicData?.name ? props.showAppoinmentData.slot.clinicData.name : ''}</p>
            <p style={{ fontSize: 14 }}>{props.showAppoinmentData?.slot?.clinicData?.address ? props.showAppoinmentData?.slot?.clinicData?.address : ''}</p>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: '410px', margin: 'auto', textAlign: 'center', marginBottom: 20 }}>
        <div style={{
          width: 100, height: 100, borderRadius: '50%', backgroundColor: '#d4eceb',
          display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto'
        }}>
          <LikeOutlined style={{ fontSize: 40, color: '#007070' }} />
        </div>
        <Title level={3} style={{ marginTop: 16 }}>Thank You!</Title>
        <Text>Your Booking Is Successful.</Text><br />
        <Text type="secondary">You should receive a confirmation email from us.</Text>
      </div>
      <div style={{
        // margin: '0 auto',
        backgroundColor: '#F0FAFA',
        height: 29,
        marginBottom: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color:"#4A4A4A",
        // fontFamily:"lato",
        fontWeight:"400",
        fontSize:"14px",
        margin:"0px 15px"
      }}>
        <span>Please check how to reach the clinic on time.</span>
      </div>

<div style={{margin:"0px 15px"}}>

      <Row justify="center" gutter={[16, 16]}  style={{ margin: "15px auto",columnGap:screens.md?"0% ":"9%"}} className='widthchange'>
      {/* Mobile: full width (xs: 24), Desktop: auto (md: 6-8) */}

      <Col xs={12} md={8} style={{ display: 'flex', justifyContent: 'center',padding:"0px"  }}>
        <Button
          type="primary"
          onClick={() => setCalendarModalOpen(true)}
          style={{
            background: '#008385',
            border: 'none',
            width: "100%",
            height: 40,
            borderRadius: 8,
          }}
        >
          Add To Calendar
        </Button>
        <Modal
          open={calendarModalOpen}
          onCancel={() => setCalendarModalOpen(false)}
          className='downloadbtnFooter'
          footer={[
          <Button type="primary" className='downloadbtnsame' onClick={() => { setCalendarModalOpen(false); onCalendarClick(); }} >
              Add To Google Calendar
            </Button>,
          <Button type="primary" className='downloadbtnsame' onClick={() => handleDownloadICS(props, setCalendarModalOpen, calendarDate)} >
              Download Calendar Invite
          </Button>,
        ]}
          title="Add To Calendar"
        >
        </Modal>
      </Col>



{/* <div className=''> */}

      <Col xs={24} md={8} style={{ display: 'flex', justifyContent: 'center',padding:"0px" }} className='button2'>
        <Button
          type="default"
          onClick={onConsultClick}
          style={{
            backgroundColor: '#C2E6E8',
            borderColor: '#008385',
            color: '#008385',
            width: 162,
            height: 40,
            borderRadius: 8,
          }}
        >
          Consultation Form
        </Button>
      </Col>

      <Col xs={12} md={8} style={{ display: 'flex', justifyContent: 'center',padding:"0px"  }}>
        <Button
          type="primary"
          onClick={showModal}
          style={{
            background: '#008385',
            border: 'none',
            width: "100%",
            height: 40,
            borderRadius: 8,
          }}
        >
          Open In Maps
        </Button>
       <Modal
        open={open}
        // title="Title"
        onOk={handleOk}
        className='mapModal'
        onCancel={handleCancel}
        footer={[
          <Button
            key="link"
            href={`https://www.google.com/maps?q=${latRounded},${lngRounded}`}
            target="_blank"
            loading={loading}
            onClick={applemap}
            className='mapButton'
          >
           Open  in Google Maps
          </Button>,
          <Button
            key="link"
            href={ `https://maps.apple.com/?q=${latRounded},${lngRounded}`}
            target="_blank"
            loading={loading}
            onClick={applemap}
            className='mapButton'
          >
            Open in Apple Maps
          </Button>,
        ]}
      >
        <div style={{ textAlign: 'left', marginLeft: 30,color: '#4A4A4A' }}>
            <p style={{ fontSize: 14 }}>{props?.showAppoinmentData?.slot?.clinicData?.name ? props.showAppoinmentData.slot.clinicData.name : ''}</p>
            <p style={{ fontSize: 14 }}>{props?.showAppoinmentData?.slot?.clinicData?.address ? props.showAppoinmentData?.slot?.clinicData?.address : ''}</p>
          </div>
      </Modal>
      </Col>
{/* </div> */}
    </Row>
</div>

      
    </div>
  );
};

export default BookingConfirmation; 
